import Logger from "@/helpers/logger";
import referralApi from "./referral.api";
import store from "@/store";

class ReferralService {
  async generateCelloToken() {
    try {
      const response = await referralApi.generateCelloToken();
      return response;
    } catch (error) {
      Logger.error("`generateCelloToken` service", error);
      return Promise.reject(error);
    }
  }

  async getCelloRewardDetails() {
    try {
      const response = await referralApi.getCelloRewardDetails();
      // Updated to use the namespaced action in the referral module
      store.dispatch("referral/setReferralRewardDetails", response);
      return response;
    } catch (error) {
      Logger.error("`getCelloRewardDetails` service", error);
      return Promise.reject(error);
    }
  }
}

const referralService = new ReferralService();

export default referralService;
